import { doc } from 'firebase/firestore';
import { db } from './firebase';

export const tenantSystemStatusDoc = (tenantId: string) => doc(db, 'tenant_system_status', tenantId);

export const tenantMajorIncidentDoc = (tenantId: string) => doc(db, 'tenant_major_incidents', tenantId);
